import type { Wine } from '../domain/cellar';
import { t } from '../i18n';
import { wineTypeLabel } from '../i18n/errors';

interface Props {
  wine: Wine;
  onConfirmAddToExisting: () => void;
  onKeepEditing: () => void;
}

/**
 * Shown when what the user has typed matches an existing wine's identity
 * (FR-003, Story 1 Acceptance 4): "Ce vin existe déjà dans votre cave.
 * Ajouter l'achat à ce vin ?" `recordPurchase` would merge into the
 * existing wine regardless, so this is a heads-up that lets the user
 * notice a typo before confirming, not a safety net on its own.
 */
export function WineMatchPrompt({ wine, onConfirmAddToExisting, onKeepEditing }: Props) {
  return (
    <div role="alert">
      <p>{t('error.wineAlreadyExists')}</p>
      <p>
        {wine.domaine} {wine.annee} &mdash; {wine.cepage} ({wineTypeLabel(wine.typeDeVin)})
      </p>
      <button type="button" className="cta-action" onClick={onConfirmAddToExisting}>
        {t('purchase.addToExisting')}
      </button>
      <button type="button" onClick={onKeepEditing}>
        {t('common.cancel')}
      </button>
    </div>
  );
}
